import { call, put, select } from 'redux-saga/effects';
import {
  exportQuestionsFulfilled,
  exportQuestionsRejected,
  selectQAFilterCriteria,
  selectQASortCriteria,
} from 'features/qa/qaSlice';
import { exportQuestionsService } from 'features/qa/services';
import { downloadFile } from 'utils/http/downloadFile';
import { AxiosResponse } from 'axios';
import { selectRoomId } from 'features/room/roomSlice';
import { ExportQuestionsParams, QAFilterCriteria, QASortingCriteria } from 'features/qa/types';

export function* exportQuestionsSaga() {
  try {
    const roomId: string = yield select(selectRoomId);
    const filterCriteria: QAFilterCriteria = yield select(selectQAFilterCriteria);
    const sortCriteria: QASortingCriteria = yield select(selectQASortCriteria);

    // Convert QASortingCriteria to SortByType and OrderType
    let filter: ExportQuestionsParams['filter'];
    if (filterCriteria === 'all') {
      filter = 'all';
    } else if (filterCriteria === 'opened') {
      filter = 'open';
    } else {
      filter = filterCriteria;
    }

    // Determine sortBy and order based on sortCriteria
    let sortBy: ExportQuestionsParams['sortBy'];
    let order: ExportQuestionsParams['order'];

    if (sortCriteria === 'votes') {
      sortBy = 'votes';
    } else {
      sortBy = 'date';
      order = sortCriteria;
    }

    const params: ExportQuestionsParams = {
      filter,
      sortBy,
      order,
    };

    const response: AxiosResponse<Blob> = yield call(exportQuestionsService, roomId, params);
    const contentDisposition = response.headers['content-disposition'];

    yield call(downloadFile, response.data, contentDisposition);

    yield put(exportQuestionsFulfilled());
  } catch (error) {
    yield put(exportQuestionsRejected());
  }
}
